<template>
  <div class="user-reward-item">
    <TavernFlipCoinBetStatusWin
      :style="{ color: isMe(userData?.userAddress) ? '#fff' : '#a2a2a2' }"
      :is-win="isWinner"
    />
    <div class="reward-wrapper" :class="{ 'green-wrapper': userData?.seasonPoints && isMe(userData?.userAddress) }">
      <div v-if="isWinner" class="reward-token">
        <img
          class="reward-icon"
          :src="tokens[tokenMetaData(blockchain.contracts, rowScope?.tokenAddress).name.contract as Tokens].toString()"
          width="26"
          loading="lazy"
          alt="Pearl Token Icon"
        />
        <span class="reward-amount">{{
          formatAmount(
            BigNumber(
              isWinner || (isMe(userData?.userAddress) && userData?.seasonPoints) ? rowScope?.winAmount : 0
            ).toNumber()
          )
        }}</span>
      </div>
      <div v-if="isMe(userData?.userAddress) && userData?.seasonPoints" class="reward-token">
        <img
          class="reward-icon"
          :src="tokens.seasonPoints.toString()"
          width="26"
          loading="lazy"
          alt="Pearl Token Icon"
        />
        <span class="reward-amount">
          +
          {{ formatAmount(BigNumber(userData?.seasonPoints || 0).toNumber()) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { getAddress } from 'ethers';
import tokens from '~/public/img/tokens';
import type { Tokens } from '~/utils/constants';
import BigNumber from 'bignumber.js';
import type { FlipCoinGame, FlipCoinPlayer } from '~/types/FlipCoin';

const { address } = useWeb3ModalAccount();
const { blockchain } = useEnvs();

const isMe = (betAddress: string) => {
  if (!address.value || !betAddress) return false;
  return address.value && getAddress(address.value) === getAddress(betAddress);
};

defineProps<{ rowScope: FlipCoinGame; userData: FlipCoinPlayer; isWinner: boolean }>();
</script>
<style lang="scss" scoped>
.user-reward-item {
  display: flex;
  align-items: center;
  gap: 10px;

  @media screen and (max-width: 479px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.reward-token {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.reward-token .reward-icon {
  width: 26px;
  height: 26px;
}

.reward-token .reward-amount {
  font-family: Eczar;
  font-weight: 700;
  font-size: 16px;
  leading-trim: Cap height;
  line-height: 17.6px;
  color: #fff;
}

.reward-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.green-wrapper {
  border-radius: 10px;
  padding: 2px 5px;
  background-image: linear-gradient(to bottom, #00a906, #000701 80%);
}
</style>
